import { Vertical } from '@repo/supergraph/marketplace/constants';

export const isValidProductType = (productType?: string): productType is Vertical =>
  productType === Vertical.Banking;
